import React, { Component } from 'react';
import { Form, Input, Button, Row, Col, Tabs, DatePicker, Select, message} from 'antd';
import axios from 'axios';
import { Link } from 'react-router-dom';


const TabPane = Tabs.TabPane;

const API_HOST_URL = process.env.REACT_APP_API_URL

class CreateForm extends Component {
    
    state = {
        employee: {},
        jobTitles: [],
        departments: [],
        divisions: [],
        locations: []
    }
    
    componentDidMount(){
        const { match : {params } } = this.props;
        console.log("Employee Props: ", this.props)

        if(params.employeeId){
            console.log("Employee Id: ",params.employeeId)
            this.fetchEmployee(params.employeeId)
        }

        this.fetchJobTitles();
        this.fetchDepartments();
        this.fetchDivisions();
        this.fetchLocations();

        
    }

    fetchEmployee(employeeId){
        axios.get(`${API_HOST_URL}/api/employee/employee/${employeeId}/?expand=department&expand=jobTitle`)
          .then(res => {
            this.setState({
              employee: res.data
            })
            console.log(res.data);
          })
      }
    
    handleSelectChangeGender = (value) => {
        console.log(value);
        this.props.form.setFieldsValue({
            gender:  value
        });
    }
    
    handleSelectChangeMaritalStatus = (value) => {
        console.log(value);
        this.props.form.setFieldsValue({
            maritalStatus:  value
        });
    }
    
    handleSelectChangeJobTitle = (value) => {
        console.log(value);
        this.props.form.setFieldsValue({
            jobTitle:  value
        });
    }
    
    handleSelectChangeDepartment = (value) => {
        console.log(value);
        this.props.form.setFieldsValue({
            department:  value
        });
    }
    
    handleSelectChangeDivision = (value) => {
        console.log(value);
        this.props.form.setFieldsValue({
            division:  value
        });
    }
    
    handleSelectChangeLocation = (value) => {
        console.log(value);
        this.props.form.setFieldsValue({
            location:  value
        });
    }
    
    
    fetchJobTitles = () => {
        axios.get(`${API_HOST_URL}/api/systemsetup/jobtitle/`)
        .then(res => {
            this.setState({
                jobTitles: res.data
            })
        })
    }
    
    fetchDepartments = () => {
        axios.get(`${API_HOST_URL}/api/systemsetup/department/`)
        .then(res => {
            this.setState({
                departments: res.data
            })
        })
    }
    
    fetchDivisions = () => {
        axios.get(`${API_HOST_URL}/api/systemsetup/division/`)
        .then(res => {
            this.setState({
                divisions: res.data
            })
        })
    }
    
    fetchLocations = () => {
        axios.get(`${API_HOST_URL}/api/systemsetup/location/`)
        .then(res => {
            this.setState({
                locations: res.data
            })
        })
    }
    
    handleFormSubmit = (event)=> {
        event.preventDefault();
        
        const form = this.props.form;
        const { match : {params } } = this.props;
        form.validateFields((err, values) => {
            if (err) {
                console.log(err);
                    message.warning('Ensure you have filled in all mandatory fields for the employee.');
                return;
            }
            console.log(values);

            if(params.employeeId){
                axios.put(`${API_HOST_URL}/api/employee/employee/${params.employeeId}/`, {
                    employeeCode: values.employeeCode,
                    firstName: values.firstName,
                    middleName: values.middleName,
                    lastName: values.lastName,
                    dateOfBirth: values.dateOfBirth,
                    gender: values.gender,
                    maritalStatus: values.maritalStatus,
                    nssfNumber: values.nssfNumber,
                    nhifNumber: values.nhifNumber,
                    pinNumber: values.pinNumber,
                    idCardNumber: values.idCardNumber,
                    email: values.email,
                    phoneNumber: values.phoneNumber,
                    
                    hireDate: values.hireDate,
                    jobTitle: values.jobTitle,
                    department: values.department,
                    division: values.division,
                    location: values.location
                    
                })
                .then(res => {
                    message.success("Employee information updated successfully.")
                    console.log(res)
                })
                .catch(error =>{
                    message.error("A problem occured. Employee information not updated.")
                    console.log(error);
                } );
            } else {
            
            axios.post(`${API_HOST_URL}/api/employee/employee/`, {
            employeeCode: values.employeeCode,
            firstName: values.firstName,
            middleName: values.middleName,
            lastName: values.lastName,
            dateOfBirth: values.dateOfBirth,
            gender: values.gender,
            maritalStatus: values.maritalStatus,
            nssfNumber: values.nssfNumber,
            nhifNumber: values.nhifNumber,
            pinNumber: values.pinNumber,
            idCardNumber: values.idCardNumber,
            email: values.email,
            phoneNumber: values.phoneNumber,
            
            hireDate: values.hireDate,
            jobTitle: values.jobTitle,
            department: values.department,
            division: values.division,
            location: values.location
            
        })
        .then(res => {
            message.success("Employee Saved successfully.")
            console.log(res)
            form.resetFields();
        })
        .catch(error =>{
            message.error("A problem occured. Employee not saved!")
            console.log(error);
        } );
    }
        
    });
}

render() {
    const { getFieldDecorator } = this.props.form;
    const { Option } = Select;
    
    return (
        <div>
        <Row type="flex" justify="end">
        <Col span={4} style={{ padding: 4}}>
        <Link to="/employee">Employees List</Link>
        </Col>
        </Row>
        
        <Form onSubmit={this.handleFormSubmit}>
        <Tabs defaultActiveKey="1" >
    <TabPane tab="Personal Details" key="1">
    <Row type="flex">
    <Col span={7} style={{ padding: 6}}>
    <Form.Item label="Employee Code">
    {getFieldDecorator('employeeCode', {
        initialValue: this.state.employee.employeeCode,
        rules: [{ required: true, message: 'Please input Employee Code!' }], 
    })( 
        <Input name="employeeCode" placeholder="Employee Code" />
    )} 
    
    </Form.Item>
    </Col>
    </Row>
    <Row type="flex">
    <Col span={7} style={{ padding: 6}}>
    <Form.Item label="First Name">
    {getFieldDecorator('firstName', {
        initialValue: this.state.employee.firstName,
        rules: [{ required: true, message: 'Please input First Name!' }], 
    })( 
        <Input name="firstName" placeholder="First Name" />
    )} 
    
    </Form.Item>
    </Col>
    <Col span={7} style={{ padding: 6}}>
    <Form.Item label="Middle Name">
    {getFieldDecorator('middleName', {
        initialValue: this.state.employee.middleName,
        rules: [{ required: false }] 
    })( 
        <Input name="middleName" placeholder="Middle Name" />
    )} 
    
    </Form.Item>
    </Col>
    <Col span={7} style={{ padding: 6}}>
    <Form.Item label="Last Name">
    {getFieldDecorator('lastName', {
        initialValue: this.state.employee.lastName,
        rules: [{ required: true, message: 'Please input Last Name!' }], 
    })( 
        <Input name="lastName" placeholder="Last Name" />
    )} 
    
    </Form.Item>
    </Col>
    </Row>
    <Row type="flex">
    <Col span={7} style={{ padding: 6}}>
    <Form.Item 
    label="Date Of Birth">
    {getFieldDecorator('dateOfBirth', {
        initialValue: this.state.employee.dateOfBirth,
        rules: [{ type: 'object', required: false }], 
    })( 
        <DatePicker format="YYYY-MM-DD" /> 
    )} 
    </Form.Item>
    </Col>
    <Col span={7} style={{ padding: 6}}>
    <Form.Item label="Gender">
    {getFieldDecorator('gender', {
        initialValue: this.state.employee.gender,
        rules: [{ required: true, message: 'Please select Gender!' }]
    })(
        <Select
        placeholder="Select Gender"
        onChange={ this.handleSelectChangeGender } >
        <Option key="Male" value="Male">Male</Option>
        <Option key="Female" value="Female">Female</Option>
        </Select>
    )}
    </Form.Item>
    </Col>
    <Col span={7} style={{ padding: 6}}>
    <Form.Item label="Marital Status">
    {getFieldDecorator('maritalStatus', {
        initialValue: this.state.employee.maritalStatus,
        rules: [{ required: true, message: 'Please select Marital Status!' }],
    })(
        <Select
        placeholder="Select Marital Status"
        onChange={ this.handleSelectChangeMaritalStatus } >
        <Option key="Married" value="Married">Married</Option>
        <Option key="Single" value="Single">Single</Option>
        </Select>
    )}
    </Form.Item>
    </Col>
    </Row>
    <Row type="flex">
    <Col span={7} style={{ padding: 6}}>
    <Form.Item label="NSSF Number">
    {getFieldDecorator('nssfNumber', {
        initialValue: this.state.employee.nssfNumber,
        rules: [{ required: false }], 
    })( 
        <Input  placeholder="NSSF Number" />
    )} 
    
    </Form.Item>
    </Col>
    <Col span={7} style={{ padding: 6}}>
    <Form.Item label="NHIF Number">
    {getFieldDecorator('nhifNumber', {
        initialValue: this.state.employee.nhifNumber,
        rules: [{ required: false }], 
    })( 
        <Input name="nhifNumber" placeholder="NHIF Number" />
    )} 
    
    </Form.Item>
    </Col>
    <Col span={7} style={{ padding: 6}}>
    <Form.Item label="PIN Number">
    {getFieldDecorator('pinNumber', {
        initialValue: this.state.employee.pinNumber,
        rules: [{ required: false }], 
    })( 
        <Input name="pinNumber" placeholder="PIN Number" />
    )} 
    
    </Form.Item>
    </Col>
    <Col span={7} style={{ padding: 6}}>
    <Form.Item label="ID Card Number">
    {getFieldDecorator('idCardNumber', {
        initialValue: this.state.employee.idCardNumber,
        rules: [{ required: false }], 
    })( 
        <Input name="idCardNumber" placeholder="ID Card Number" />
    )} 
    
    </Form.Item>
    </Col>
    <Col span={7} style={{ padding: 6}}>
    <Form.Item label="Email">
    {getFieldDecorator('email', {
        initialValue: this.state.employee.email,
        rules: [{ required: false }], 
    })( 
        <Input name="email" placeholder="Email" />
    )} 
    
    </Form.Item>
    </Col>
    <Col span={7} style={{ padding: 6}}>
    <Form.Item label="Phone Number">
    {getFieldDecorator('phoneNumber', {
        initialValue: this.state.employee.phoneNumber,
        rules: [{ required: false }], 
    })( 
        <Input name="phoneNumber" placeholder="Phone Number" />
    )} 
    
    </Form.Item>
    </Col>
    </Row>
    </TabPane>
        
    <TabPane tab="Job" key="2">
    <Row type="flex">
    <Col span={7} style={{ padding: 6}}>
    <Form.Item 
    label="Hire Date">
    {getFieldDecorator('hireDate', {
        initialValue: this.state.employee.hireDate,
        rules: [{ type: 'object', required: false }], 
    })( 
        <DatePicker format="YYYY-MM-DD" /> 
    )} 
    </Form.Item>
    </Col>
    <Col span={7} style={{ padding: 6}}>
    <Form.Item label="Job Title">
    {getFieldDecorator('jobTitle', {
        initialValue: this.state.employee.jobTitle ? this.state.employee.jobTitle.id : '',
        rules: [{ required: false }],
    })(
        <Select
        placeholder="Select Job Title"
        onChange={this.handleSelectChangeJobTitle}
        >
        {
            this.state.jobTitles.map(jobTitle => 
                <Option key={jobTitle.id} value={ jobTitle.id}>{ jobTitle.jobTitle }</Option>
            )
        }
        </Select>
    )}
    </Form.Item>
    </Col>
    <Col span={7} style={{ padding: 6}}>
    <Form.Item label="Reports To">
    <Input name="reportsTo" placeholder="Reports To" />
    </Form.Item>
    </Col>
    </Row>
    <Row type="flex">
    <Col span={7} style={{ padding: 6}}>
    <Form.Item label="Department">
    {getFieldDecorator('department', {
        initialValue: this.state.employee.department ? this.state.employee.department.id : '',
        rules: [{ required: false }],
    })(
        <Select
        placeholder="Select Department"
        onChange={this.handleSelectChangeDepartment}
        >
        {
            this.state.departments.map(department => 
                <Option key={department.id} value={ department.id}>{ department.department }</Option>
            )
        }
        </Select>
    )}
    </Form.Item>
    </Col>
    <Col span={7} style={{ padding: 6}}>
    <Form.Item label="Division">
    {getFieldDecorator('division', {
        initialValue: this.state.employee.division ? this.state.employee.division.id : '',
        rules: [{ required: false }],
    })(
        <Select
        placeholder="Select Division"
        onChange={this.handleSelectChangeDivision}
        >
        {
            this.state.divisions.map(division => 
                <Option key={division.id} value={ division.id}>{ division.division }</Option>
            )
        }
        </Select>
    )}
    </Form.Item>
    </Col>
    <Col span={7} style={{ padding: 6}}>
    <Form.Item label="Location">
    {getFieldDecorator('location', {
        initialValue: this.state.employee.location ? this.state.employee.location.id : '',
        rules: [{ required: false }],
    })(
        <Select
        placeholder="Select Location"
        onChange={this.handleSelectChangeLocation}
        >
        {
            this.state.locations.map(location => 
                <Option key={location.id} value={ location.id}>{ location.location }</Option>
            )
        }
        </Select>
    )}
    </Form.Item>
    </Col>
    </Row>
    </TabPane>
    </Tabs>
    <Form.Item>
    <Button type="primary" htmlType="submit">Save</Button>
    </Form.Item>
    </Form>
    
    </div>
);
}
}

const EmployeeCreate = Form.create({ name: 'employee_form' })(CreateForm)

export default EmployeeCreate;